// Exact-email allow-list for sign-in (auth polish Item 1).
//
// The domain allow-list is env-driven (ALLOWED_EMAIL_DOMAINS server /
// VITE_ALLOWED_EMAIL_DOMAINS client). This module is the *exact-email*
// escape hatch for external collaborators who don't have a kyck.com.au /
// kyck.co.nz address. It's a committed constant (not env) so a teammate
// can add an external user with a one-line code change + deploy — no
// env-var plumbing on both the client (VITE_ rebuild) and the server.
//
// Deliberately Vite-free (no import.meta) so the server can import it
// directly the same way it imports other src/lib pure helpers — keeping a
// single source of truth shared by the client guard and the server
// middleware. Low sensitivity (an email address), same "committed list"
// posture as BOOTSTRAP_ADMIN_EMAILS.
//
// To add an external user: add their lowercase email to ALLOWED_EMAILS,
// commit, deploy. To remove access: delete the line, commit, deploy.
export const ALLOWED_EMAILS: readonly string[] = [
  'ernestobarbz21@gmail.com',
  'production@crikeycustoms.com.au',
];

// True iff the given email exactly matches an entry in ALLOWED_EMAILS
// (case-insensitive). Domain-based access is handled separately by the
// caller; login passes if EITHER check passes.
export function isExactEmailAllowed(
  email: string | null | undefined,
): boolean {
  if (!email) return false;
  const normalized = email.trim().toLowerCase();
  if (!normalized) return false;
  return ALLOWED_EMAILS.includes(normalized);
}
